import { render, staticRenderFns } from "./destination-form.vue?vue&type=template&id=04f066ed&"
import script from "./destination-form.vue?vue&type=script&lang=js&"
export * from "./destination-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports